<template>
  <section class="c-gallery position-relative">
    <div class="c-bg-primary position-absolute w-100 h-50">
      <span class="c-tt position-absolute">
        <img alt="tiktok" class="w-100" src="@/assets/img/tt.png">
      </span>
      <span class="c-inst position-absolute">
        <img alt="instagram" class="w-100" src="@/assets/img/inst.png">
      </span>
    </div>
    <div class="container-fluid position-relative">
      <h2 class="c-gallery__title white text-center">
        ELIGE Y DESCARGA LA IMAGEN QUE MÁS TE GUSTA
      </h2>
      <div class="c-slider-container">
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <label for="1" class="c-option">
                <figure class="c-card position-relative">
                  <img alt="instagram" class="w-100" src="@/assets/img/bg-inst.png">
                  <div class="c-card__photo position-absolute">
                    <img alt="instagram" class="w-100" src="@/assets/img/photo-1.jpg">
                  </div>
                </figure>
                <div class="mt-4 text-center">
                  <input v-model="picture" value="1" id="1" type="radio">
                </div>
              </label>
            </div>
            <div class="swiper-slide">
              <label for="2" class="c-option">
                <figure class="c-card position-relative">
                  <img alt="instagram" class="w-100" src="@/assets/img/bg-inst.png">
                  <div class="c-card__photo position-absolute">
                    <img alt="instagram" class="w-100" src="@/assets/img/photo-2.jpg">
                  </div>
                </figure>
                <div class="mt-4 text-center">
                  <input v-model="picture" value="2" id="2" type="radio">
                </div>
              </label>
            </div>
            <div class="swiper-slide">
              <label for="3" class="c-option">
                <figure class="c-card position-relative">
                  <img alt="instagram" class="w-100" src="@/assets/img/bg-inst.png">
                  <div class="c-card__photo position-absolute">
                    <img alt="instagram" class="w-100" src="@/assets/img/photo-3.jpg">
                  </div>
                </figure>
                <div class="mt-4 text-center">
                  <input v-model="picture" value="3" id="3" type="radio">
                </div>
              </label>
            </div>
            <div class="swiper-slide">
              <label id="4" class="c-option">
                <figure class="c-card position-relative">
                  <img alt="instagram" class="w-100" src="@/assets/img/bg-inst.png">
                  <div class="c-card__photo position-absolute">
                    <img alt="instagram" class="w-100" src="@/assets/img/photo-4.jpg">
                  </div>
                </figure>
                <div class="mt-4 text-center">
                  <input v-model="picture" value="4" id="4" type="radio">
                </div>
              </label>
            </div>
            <div class="swiper-slide">
              <label  id="5" class="c-option">
                <figure class="c-card position-relative">
                  <img alt="instagram" class="w-100" src="@/assets/img/bg-inst.png">
                  <div class="c-card__photo position-absolute">
                    <img alt="instagram" class="w-100" src="@/assets/img/photo-5.jpg">
                  </div>
                </figure>
                <div class="mt-4 text-center">
                  <input v-model="picture" value="5" id="5" type="radio">
                </div>
              </label>
            </div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
      <div class="text-center">
        <div class="c-form-btn mt-4 d-flex justify-content-center align-items-center">
          <button
            @click="updateParticipant()"
            class="c-button c-button--lg d-flex align-items-center"
          >
          {{ (isLoading) ? 'Descargando...' : 'Descargar y finalizar' }}
            <img alt="icono de descarga" src="@/assets/img/dl.png">
          </button>
        </div>
      </div>
    </div>
    <ModalError
      title="Error al descargar imágen"
      body="¡Necesitas elegir una imágen para descargar! 😥⚠️🚨." />
  </section>
</template>

<script>
import Swiper from 'swiper';

export default {
  data() {
    return {
      picture: '',
      isLoading: false,

      sliderPictures: '',
    };
  },
  props: ['step', 'participantId', 'pictureIG'],
  components: {
    ModalError: () => import(/* webpackChunkName: "modal-error" */'../ModalError.vue'),
  },
  mounted() {
    setTimeout(() => {
      this.sliderPictures = new Swiper('.mySwiper', {
        slidesPerView: 1,
        spaceBetween: 5,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          600: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 5,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 0,
          },
        },
      });
    }, 500);
  },
  methods: {
    downloadImage() {
      const file = `${process.env.VUE_APP_SITE}/wp-content/uploads/ig/photo-${this.picture}.jpg`;
      const name = 'ImagenPublicacion.jpg';

      fetch(file)
        .then((resp) => resp.blob())
        .then((blob) => {
          this.isLoading = false;
          this.$emit('update:pictureIG', this.picture);
          this.$emit('update:step', 3);

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;

          a.download = name;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => { throw err; });
    },

    updateParticipant() {
      this.isLoading = true;

      if (this.picture) {
        fetch(`${process.env.VUE_APP_API}/participants/${this.participantId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            picture: this.picture,
          }),
        })
          .then((res) => {
            if (res.status >= 200 && res.status < 300) {
              this.downloadImage();

              return res.json();
            }

            throw res;
          })
          .catch((err) => {
            this.isLoading = false;

            throw err;
          });
      } else {
        this.$bvModal.show('modalError');
      }
    },
  },
};

</script>
